module.exports = __webpack_public_path__ + "static/media/Aesara-Lucania-2.1ef2c044.gif";